(function () {
  const COOKIE_NAME = 'discount_code';
  const STORAGE_KEY = 'shopify:discount_code';
  const TARGET_SELECTOR = '#athlete-discount';

  // default affiché si on ne peut pas déduire le % (ex: codes prenom/nom)
  const DEFAULT_PERCENT = 15;

  // exceptions explicites (codes sans chiffres qui ne sont PAS à 15%)
  const DISCOUNT_CODE_TO_PERCENT = {
    'ELITE-GROUPS': 30,
    'SPORTS-CLUBS': 15,
    'FRIENDS-FAMILY': 25,
  };

  function waitForElement(selector, callback, timeout = 5000) {
    const start = Date.now();
    function check() {
      const el = document.querySelector(selector);
      if (el) callback(el);
      else if (Date.now() - start < timeout) requestAnimationFrame(check);
    }
    check();
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function getDiscountCode() {
    try {
      const urlCode = new URLSearchParams(window.location.search).get('discount');
      return urlCode || getCookie(COOKIE_NAME) || localStorage.getItem(STORAGE_KEY);
    } catch {
      return getCookie(COOKIE_NAME) || localStorage.getItem(STORAGE_KEY);
    }
  }

  function setVisibility(pEl, visible) {
    if (!pEl) return;
    pEl.style.display = visible ? '' : 'none';
    if (visible) pEl.removeAttribute('aria-hidden');
    else pEl.setAttribute('aria-hidden', 'true');
  }

  function getLang() {
    return (document.documentElement.lang || '').toLowerCase();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // Fallback si ton code contient un nombre (DISCOUNT30, ATHLETE15, -20, etc.)
  function parsePercentFromCode(code) {
    if (!code) return null;
    const s = String(code).toUpperCase();
    const m = s.match(/(\d{1,3})(?:\s?%|$)/);
    if (!m) return null;
    const n = Number(m[1]);
    if (!Number.isFinite(n) || n <= 0 || n > 100) return null;
    return n;
  }

  // Tentative: appliquer le code au panier + lire /cart.js
  // (si ton discount n’apparait qu’au checkout, ça peut renvoyer null)
  async function fetchDiscountPercentFromShopify(code) {
    const clean = String(code || '').trim();
    if (!clean) return null;

    try {
      await fetch(`/discount/${encodeURIComponent(clean)}?redirect=/cart`, {
        credentials: 'same-origin',
        redirect: 'follow',
      });
    } catch {}

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return null;
      const cart = await res.json();

      const apps = Array.isArray(cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications
        : [];

      if (!apps.length) return null;

      const upper = clean.toUpperCase();
      const app =
        apps.find((a) => String(a.title || '').toUpperCase() === upper) ||
        apps.find((a) => String(a.title || '').toUpperCase().includes(upper)) ||
        apps[0];

      if (!app) return null;

      const valueType = String(app.value_type || '').toLowerCase();
      const value = Number(app.value);

      if (valueType === 'percentage' && Number.isFinite(value)) {
        return Math.round(value);
      }

      return null;
    } catch {
      return null;
    }
  }

  function render(code, pEl, percent) {
    if (!pEl) return;

    if (!code) {
      setVisibility(pEl, false);
      return;
    }

    setVisibility(pEl, true);

    const upperCode = String(code).trim().toUpperCase();
    const safeCode = escapeHtml(upperCode);
    const lang = getLang();

    const discountLabel = percent != null ? `-${percent}%` : `-${DEFAULT_PERCENT}%`;

    if (lang.startsWith('fr')) {
      pEl.innerHTML = `${discountLabel} AVEC <span>${safeCode}</span> APPLIQUÉ AU CHECKOUT`;
    } else {
      pEl.innerHTML = `${discountLabel} WITH <span>${safeCode}</span> APPLIED AT CHECKOUT`;
    }
  }

  async function init() {
    waitForElement(TARGET_SELECTOR, async (pEl) => {
      setVisibility(pEl, false);

      const code = getDiscountCode();
      if (!code) return;

      localStorage.setItem(STORAGE_KEY, code);

      const upper = String(code).trim().toUpperCase();

      // 1) Shopify (si dispo)
      let percent = await fetchDiscountPercentFromShopify(upper);

      // 2) parse digits (DISCOUNT30 / ATHLETE15)
      if (percent == null) percent = parsePercentFromCode(upper);

      // 3) mapping exceptions (ELITE-GROUPS -> 30)
      if (percent == null && DISCOUNT_CODE_TO_PERCENT[upper] != null) {
        percent = DISCOUNT_CODE_TO_PERCENT[upper];
      }

      // 4) default 15% si toujours rien
      if (percent == null) percent = DEFAULT_PERCENT;

      render(upper, pEl, percent);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
